import { BaseRequestModel } from '../../../base/base.request.model';

export class GetContactRequestModel extends BaseRequestModel {
  contactID?: string;
  locale?: string;
}
